/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button} from '@mui/material';

export const ButtonsBox = styled(Box)(() => ({
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  width: 'max-content',
}));

export const StyledButton = styled(Button)(({theme}) => ({
  width: 'max-content',
  minWidth: 'unset',
  height: '32px',
  padding: theme.spacing(0, 2),
  position: 'relative',
  overflow: 'hidden',
  background: 'none',
  borderRadius: 0,

  '&:hover': {
    background: 'none',
  },
}));

interface BgBoxProps {
  customColor: string;
  checked: boolean;
}

export const BgBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'customColor',
})<BgBoxProps>(({customColor, checked}) => ({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 0,
  background: customColor,
  opacity: checked ? 0.4 : 0.2,
  transition: '0.2s',
}));

interface HoverBoxProps {
  isHovered: boolean;
}

export const HoverBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'isHovered',
})<HoverBoxProps>(({theme, isHovered}) => ({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 2,
  opacity: isHovered ? 0.2 : 0,
  background: theme.palette.primary?.main,
  transition: '0.2s',
}));

export const Content = styled(Box)(({theme}) => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',

  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));
